import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
  TYPE_INSTANCE1,
} from "App/constants";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import { useSelectOption } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  isNull,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const RESET_STATE_POLIKLINIK_SPESIALIS = {
  id: "",
  poli_room_code: "",
  poli_name: "",
  spec_code: "",
  spec_name: "",
  remark: "",
};

export const getAllPoliklinikSpesialis = async () => {
  try {
    const api = await instance1.get(LIST_URL_MASTER.poliklinik_spesialis.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deletePoliklinikSpesialisById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance1.post(
      LIST_URL_MASTER.poliklinik_spesialis.delete,
      {},
      {
        headers: {
          idpoliclinicspesialist: id,
        },
      }
    );
    const newData = await fetchData(
      TYPE_INSTANCE1,
      LIST_URL_MASTER.poliklinik_spesialis.list
    );
    setRows(newData);
    setShowModalDeleteConfirm(false);
    setFormData(RESET_STATE_POLIKLINIK_SPESIALIS);
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "poli_room_code",
    disablePadding: false,
    label: "KODE KAMAR POLI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "spec_code",
    disablePadding: false,
    label: "KODE SPESIALIS",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, formData, setFormData, setRows }) => {
  const spesialis = useSelectOption(
    true,
    "/spesialist/listspesialist_pls",
    TYPE_INSTANCE1,
    "code",
    "name"
  );

  const poliklinik = useSelectOption(
    true,
    "/policlinic/listpoliclinic_pl",
    TYPE_INSTANCE1,
    "code",
    "name"
  );

  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const addPoliklinikSpesialis = async () => {
    return instance1.post(LIST_URL_MASTER.poliklinik_spesialis.add, {
      ...formData,
    });
  };

  const updatePoliklinikSpesialis = () => {
    return instance1.post(
      LIST_URL_MASTER.poliklinik_spesialis.update,
      {
        ...formData,
      },
      {
        headers: {
          idpoliclinicspesialist: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    if (formData.poli_room_code === "" || formData.spec_code === "") {
      defaultToastError(
        "Kode Kamar Poli dan Kode Spesialis tidak boleh kosong"
      );
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    }

    try {
      if (formData.id === "") {
        await addPoliklinikSpesialis();
      } else if (formData.id !== "") {
        await updatePoliklinikSpesialis();
      }
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      setShowModal(false);
      const newData = await fetchData(
        TYPE_INSTANCE1,
        LIST_URL_MASTER.poliklinik_spesialis.list
      );
      setRows(newData);
    } catch (error) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Poliklinik Spesialis`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputOptionMaster
              name='poli_room_code'
              label='Poliklinik'
              id='poli_room_code'
              value={formData.poli_room_code}
              labelValue={formData.poli_name}
              withSearch={true}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    poli_room_code: null,
                    poli_name: "Pilih Poliklinik",
                  });
                } else {
                  setFormData({
                    ...formData,
                    poli_room_code: e.value,
                    poli_name: e.label,
                  });
                }
              }}
              data={poliklinik}
            />
          </Grid>

          <Grid item sm={12}>
            <InputOptionMaster
              name='spec_code'
              label='Spesialis'
              id='spec_code'
              withSearch={true}
              value={formData.spec_code}
              labelValue={formData.spec_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    spec_code: null,
                    spec_name: "Pilih Spesialis",
                  });
                } else {
                  setFormData({
                    ...formData,
                    spec_code: e.value,
                    spec_name: e.label,
                  });
                }
              }}
              data={spesialis}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Remark'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
